import { Routes, Route } from 'react-router-dom';
import {
  PrivateRoute,
  PublicRoute,
  RegisterRoute,
  RootRedirect,
} from './components/common/PrivateRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Team from './pages/Team';
import Reports from './pages/Reports';
import ReportDetail from './pages/ReportDetail';
import MeetingNew from './pages/MeetingNew';
import Meetings from './pages/Meetings';
import PublicReportFill from './pages/PublicReportFill';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/fill/:token" element={<PublicReportFill />} />

      <Route
        path="/register"
        element={
          <RegisterRoute>
            <Register />
          </RegisterRoute>
        }
      />

      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />

      <Route
        path="/team"
        element={
          <PrivateRoute>
            <Team />
          </PrivateRoute>
        }
      />

      <Route
        path="/reports"
        element={
          <PrivateRoute>
            <Reports />
          </PrivateRoute>
        }
      />

      <Route
        path="/reports/:id"
        element={
          <PrivateRoute>
            <ReportDetail />
          </PrivateRoute>
        }
      />

      <Route
        path="/meetings/new"
        element={
          <PrivateRoute>
            <MeetingNew />
          </PrivateRoute>
        }
      />

      <Route
        path="/meetings"
        element={
          <PrivateRoute>
            <Meetings />
          </PrivateRoute>
        }
      />

      <Route path="/" element={<RootRedirect />} />
      <Route path="*" element={<RootRedirect />} />
    </Routes>
  );
};

export default AppRoutes;
